<template>
  <div>
    <!-- 业绩排他 -->
    <el-dialog
      title="业绩排他"
      :visible.sync="showDialog"
      width="30%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="cancelAction"
    >
      <el-main>
        <el-row>
          <el-col :span="24">
            <div>选择排他单元</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div>
              <el-select
                v-model="selectValue"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="请选择"
                :remote-method="remoteMethod"
                style="width: 400px"
              >
                <el-option
                  v-for="item in options"
                  :key="item.store_id"
                  :label="item.store_name"
                  :value="item.store_id"
                />
              </el-select>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12"
            ><div>
              <el-select v-model="selectValue" placeholder="请选择">
                <el-option
                  v-for="item in list"
                  :key="item.store_id"
                  :label="item.store_name"
                  :value="item.store_id"
                >
                </el-option>
              </el-select></div
          ></el-col>
          <el-col :span="12"><el-button @click="addUnit">添加</el-button></el-col>
        </el-row> -->
        <!-- <el-row>
          <el-col :span="24"><div>已添加的排他单元</div></el-col>
        </el-row> -->
        <!-- <el-row v-for="(v, i) in exclusionList" :key="i">
          <el-col :span="24"
            ><el-tag>{{ v }}</el-tag></el-col
          >
        </el-row> -->
      </el-main>
      <el-footer>
        <el-button @click="cancelAction">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >
          确定
        </el-button>
      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
import { getStoreList } from '@/api/component'

export default {
  name: 'Exclusion',
  props: {
    exclusionVisible: {
      type: Boolean,
      default: false
    },
    excludeOperateStore: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      list: [],
      selectValue: [],
      exclusionList: ['选项1', '选项3'],
      options: []
    }
  },
  computed: {
    showDialog () {
      return this.exclusionVisible
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        this.getNewsList('getFirst')
        this.selectValue = this.excludeOperateStore.map((v) => {
          return Number(v)
        })
      } else {
        this.selectValue = []
      }
    }
    // selectValue(newVal) {
    //   console.log(newVal)
    // }
  },
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('exclusionVisibleChange', [false])
    },
    // 获取门店列表
    async getNewsList (type) {
      this.loading = true
      const data = await getStoreList(this.params)
      if (data) {
        this.list = data.list
        this.options = this.list
      }
    },
    // addUnit() {
    //   console.log(this.selectValue)
    // },
    remoteMethod (query) {
      if (query !== '') {
        this.options = this.list.filter((item) => {
          return item.store_name.indexOf(query) > -1
        })
      } else {
        this.options = this.list
      }
    },
    handleConfirm () {
      this.$emit('exclusionVisibleChange', [false, this.selectValue])
    }
  }
}
</script>

<style lang="scss" scoped>
.bb {
  border-bottom: 1px solid #e9e9e9;
}
.w45 {
  width: 45%;
}
.w90 {
  width: 90%;
}
.mr10 {
  margin-right: 10px;
}
.red {
  color: red;
}
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.el-header {
  text-align: bottom;
  line-height: 60px;
}

.el-main {
  text-align: left;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-container {
  background-color: #fff;
}
.grid-content {
  min-height: 46px;
  padding: 0 5px;
}
</style>
